module.exports = __webpack_public_path__ + "static/media/chat_icon.2c435b38.svg";